export const scrollToTargetId = (targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        const yOffset = -150; // Adjust this value to offset the scroll position if needed
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
}